export const FETCH_DRIVER_REQUEST = "FETCH_DRIVER_REQUEST";
export const FETCH_DRIVER = "FETCH_DRIVER";
export const MEMBER_CONNECTIVITY_CHANGE = "MEMBER_CONNECTIVITY_CHANGE";
export const DRIVER_LOCATION_UPDATE = "DRIVER_LOCATION_UPDATE";
export const DRIVERS_LOCATIONS = "DRIVERS_LOCATIONS";
